import React from 'react';
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from '../../contexts/AuthContext';

import { AppRoutes } from './AppRoutes';

import '../../styles/index.scss';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <AuthProvider>
      <div className="app">
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          toastStyle={{
            backgroundColor: '#2b2b2b',
            color: '#e7d6af',
            border: '1px solid rgba(231, 214, 175, 0.15)',
            fontFamily: 'Manrope, sans-serif',
          }}
        />
      </div>
    </AuthProvider>
  );
}
